/* 🤖 this file was generated by svg-to-ts */

export type IconName =
  | 'flag_cs'
  | 'flag_da_dk'
  | 'flag_de_de'
  | 'flag_en_gb'
  | 'flag_en_us'
  | 'flag_es_es'
  | 'flag_es_mx'
  | 'flag_fi'
  | 'flag_fr_fr'
  | 'flag_hu'
  | 'flag_it_it'
  | 'flag_ja'
  | 'flag_ko'
  | 'flag_nb'
  | 'flag_nl_be'
  | 'flag_pl'
  | 'flag_pt_br'
  | 'flag_pt_pt'
  | 'flag_ro'
  | 'flag_se'
  | 'flag_th'
  | 'flag_tr'
  | 'flag_vi'
  | 'flag_zh_hans'
  | 'flag_zh_hant';
export interface SiriusFlag {
  name: IconName;
  data: string;
}
